<template>
  <div id="Profile">
    <div class="d-flex" v-if="status">
      <div class="profile-image">
        <img class="b-img" :src="(user.image||user.image_kakao)|image" alt="profile" v-if="(user.image||user.image_kakao)" />
        <img class="b-img" alt="profile" src="@/assets/images/pirate/profile.svg" v-else />
      </div>
      <div class="status-message">
        <v-clamp :max-lines="3" autoresize v-html="status.message" v-if="status"/>
      </div>
    </div>
    <ProfileLoader v-else/>
  </div>
</template>

<script>
import ProfileLoader from '../ProfileLoader'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Profile',
  components: {
    ProfileLoader
  },
  computed: {
    ...mapState('status', {
      status: 'status'
    }),
    ...mapGetters('auth', {
      user: 'getProfile'
    })
  }
}
</script>

<style lang="scss" scoped>
  #Profile {
    @media screen and (max-width: 350px) {
      height: calc(45vh / 647 * 100);
    }
    @media screen and (min-width: 350px) {
      height: calc(52vh / 647 * 100);
    }

    .profile-image {
      @media screen and (max-width: 350px) {
        width: 45px;
        height: 45px;
      }
      @media screen and (min-width: 350px) {
        width: 52px;
        height: 52px;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .status-message {
      width: calc(100% - 62px);
      margin-left: 10px;
      color: #727D8C;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: left;
      div {
        width: 100%;
      }
      @media screen and (max-width: 350px) {
        font-size: 13px;
        line-height: 20px;
        height: 45px;
      }
      @media screen and (min-width: 350px) {
        font-size: 15px;
        line-height: 22px;
        height: 52px;
      }
    }
  }
</style>
